
import {
    Component,
    Vue,
    Provide,
    Watch
} from 'vue-property-decorator';
import utils from '@/utils';
import axios from 'axios';
import Profile from "@/views/Profile.vue";
@Component({
  components:{
    Profile
  }
})
export default class CourseInformationOperation extends Vue {

    $route: any;
    $message: any;
    $confirm: any;
    $refs: any;

    //加载中 不可编辑信息
    @Provide() loading: Boolean = false;
    //#attribute
    @Provide() tabelHeight: number = window.innerHeight;
    //活动标签
    @Provide() activeName: string = 'first';
    //分页 金额
    @Provide() queryInfoMoney: any = {
        query: '',
        pageNum: 1, //当前页
        pageSize: 10 //当前每页显示多少条
    };
    //分页 状态
    @Provide() queryInfoState: any = {
        query: '',
        pageNum: 1, //当前页
        pageSize: 10 //当前每页显示多少条
    };
    //分页 时间
    @Provide() queryInfoTime: any = {
        query: '',
        pageNum: 1, //当前页
        pageSize: 10 //当前每页显示多少条
    };
    //金额 总信息数量
    @Provide() totalMoney = 0;
    //状态 总信息数量
    @Provide() totalState = 0;
    //状态 总信息数量
    @Provide() totalTime = 0;
    //课节信息字段
    @Provide() CourseInfoForm: any = {
        id: 0,
        //学员课程
        courseName: '',
        //总课时
        totalDuration: 0,
        //剩余课时
        leftDuration: 0,
        //服务状态外键
        serviceStateId: 1,
        //剩余预算
        remainingBudget: 0,
        //剩余预算百分比
        remainingBudgetPercentage: '',
        //平均月预算
        averageMonthlyBudget: 0,
        //实际平均月消费
        actualAverageMonthlyCost: 0,
        //暂停开始日期
        suspensionStartDate: '',
        //暂停结束日期
        suspensionEndDate: '',
        //合同开始时间
        contractStartTime: '',
        //合同结束时间
        contractEndTime: '',
        //标志总课时的状态
        totalDurationRadio: "1",
        awardAmount:0,
        budgetAmountCurrencyType:'CNY'
    };
    @Provide() stageForm: Array <any> =[];
    //服务状态选项值编辑 
    @Provide() serviceStateEdit: number = 1;
    //服务状态选项编辑  
    @Provide() serviceStateOptionsEdit: any = [];
	//费用类型
	@Provide() courseTransitionTypes: any = [];
    //编辑框显示flag
    @Provide() dialogVisible3 = false;
    //金额历史数据
    @Provide() moneyInfolist: Array < any > = [];
    //状态历史数据
    @Provide() stateInfolist: Array < any > = [];
    //时间历史数据
    @Provide() timeInfolist: Array < any > = [];
    //金额信息列
    @Provide() moneyInfoColumn: Array < object > = [{
            label: "金额增减历史表主键",
            prop: "id",
            width: "100",
            isTrue: false
        },
        {
            label: "课程外键",
            prop: "courseId",
            width: "150",
            isTrue: false
        },
        {
            label: "交易表",
            prop: "transactionId",
            width: "150",
            isTrue: false
        },
        {
            label: "金额类型外键",
            prop: "transactionType",
            width: "150",
            isTrue: false
        },
        {
            label: "波动 增减进出",
            prop: "fluctuate",
            width: "150",
            isTrue: true
        },
        {
            label: "金额类型",
            prop: "transactionTypeName",
            width: "200",
            isTrue: true
        },
        {
            label: "备注原因",
            prop: "remarks",
            width: "170",
            isTrue: true
        },
        {
            label: "货币类型",
            prop: "currencyType",
            width: "150",
            isTrue: true
        },
        {
            label: "货币数量",
            prop: "moneyAmount",
            width: "150",
            isTrue: true
        },
        {
            label: "汇率",
            prop: "currencyRate",
            width: "170",
            isTrue: true
        },
        {
            label: "记录时间(PEK)",
            prop: "beijing",
            width: "170",
            isTrue: true
        },
        {
            label: "记录时间(DFW)",
            prop: "dalas",
            width: "170",
            isTrue: true
        }
    ];
    //状态信息列
    @Provide() stateInfoColumn: Array < object > = [{
            label: "状态历史主键",
            prop: "id",
            width: "150",
            isTrue: false
        },
        {
            label: "课程外键",
            prop: "courseId",
            width: "150",
            isTrue: false
        },
        {
            label: "服务状态外键",
            prop: "serviceStateId",
            width: "150",
            isTrue: false
        },
        {
            label: "学员课程",
            prop: "courseName",
            width: "150",
            isTrue: true
        },
        {
            label: "服务状态名称",
            prop: "serviceStateName",
            width: "150",
            isTrue: true
        },
        {
            label: "记录时间(PEK)",
            prop: "beijing",
            width: "170",
            isTrue: true
        },
        {
            label: "记录时间(DFW)",
            prop: "dalas",
            width: "170",
            isTrue: true
        }
    ];
    //时间信息列
    @Provide() timeInfoColumn: Array < object > = [{
            label: "时间历史主键",
            prop: "id",
            width: "150",
            isTrue: false
        },
        {
            label: "课程外键",
            prop: "courseId",
            width: "150",
            isTrue: false
        },
        {
            label: "课程领域参考表外键",
            prop: "courseFieldReferenceTableKey",
            width: "150",
            isTrue: false
        },
        {
            label: "字段类型",
            prop: "descriptionName",
            width: "150",
            isTrue: true
        },
        {
            label: "时间",
            prop: "fieldContent",
            width: "150",
            isTrue: true
        },
        {
            label: "波动 增减进出",
            prop: "fluctuate",
            width: "150",
            isTrue: true
        },
        {
            label: "备注原因",
            prop: "remarks",
            width: "150",
            isTrue: true
        },
        {
            label: "记录时间(PEK)",
            prop: "beijing",
            width: "170",
            isTrue: true
        },
        {
            label: "记录时间(DFW)",
            prop: "dalas",
            width: "170",
            isTrue: true
        }
    ];
    //暂停中标志
    @Provide() suspendedFlag: boolean = false;
    //失败退款
    @Provide() failureRefundFlag: boolean = false;
    //成功内推
    @Provide() SuccessfulIntroversionFlag: boolean = false;
    //初步成功
    @Provide() InitialSuccess: boolean = false;
	//结束
	@Provide() serviceEnd: boolean = false;
    //表单默认为不可输入状态
    @Provide() formReadOnly: Array < boolean > = [true, true, true, true, true, true, true, true, true, true, true, true, true,true];
    //修改金额信息
    @Provide() MountInfoForm ={
        //显示弹窗标识
        dialogVisible: false,
        //金额弹窗 标题
        dialogTitle: "",
        //金额弹窗 金额属性名
        moneyAmount: "",
        TransactionId: "",
        Remarks: "",
        CurrencyType: "",
        //金额弹窗 改变金额
        dialogMoneyChange: 0,
        //金额弹窗 金额数列
        dialogMoneyAmount: 0,
        //金额弹窗 金额主键
        dialogMoneyAmountId: 0,
        //金额弹窗 金额类型
        currencyTypeOptionValue: "CNY",
        //金额弹窗 金额数列
        contractAmounRemarks: "",
        //标识 是暂存 还是 保存
        restOfName:"",
        //金额弹窗 金额类型选项
        currencyTypeOptions: [{
                label: 'CNY'
            },
            {
                label: 'USD'
            }
        ],
        disabled:false
    };

    //修改时间信息
    @Provide() TimeInfoForm ={
        //显示弹窗标识
        dialogVisible: false,
        //时间弹窗 标题
        dialogTitle: "",
        //时间弹窗 时间字段
        FieldContent: "",
        TimeRecord: "",
        Remarks: "",
        CurrencyType: "",
        totalDurationRadio:0,
        totalDuration:"",
        readOnly: true
    };

    //开始时间和结束时间信息
    @Provide() contractTimeInfoForm ={
        //显示弹窗标识
        dialogVisible: false,
        //时间弹窗 标题
        dialogTitle: "",
        //时间弹窗 时间字段
        time: "",
        //备注原因
        Remarks: "",
        //属性字段名
        fieldName:"",
        //:课程领域参考表类型
        type:1,
    };
    // 学生信息参数

    @Provide() ifShowIntegrity: boolean = false;
				//是否提交，如果正在请求后端则改为false
				//用户基本信息
	@Provide() proinfo: any ={};
				//用户教育信息
	@Provide() lastEducation: any ={};
	@Provide() pastEducation: Array <any> = [];
				//可用大学，学位，研究领域，大学成绩，公司信息——用于下拉选择
	@Provide() educationSelect: any = {};
				//被删除的教育信息id
	@Provide() delEducationIds: Array <any> = [];
				//添加大学信息对话框
	@Provide() universityDialog: boolean = false;
				//添加大学信息下标，表示新增后要返回到哪组数据
	@Provide() universityIndex: number = -1;
				//添加大学信息名称
	@Provide() universityName: String = "";
				//用户工作经验信息
	@Provide() userWorkInfo: any ={};
	@Provide() fullTimeExperience: Array <any> = [];
	@Provide() internshipExperience: Array <any> = [];
				//被删除的工作信息id
	@Provide() delExperienceIds: Array <any> = [];
				//工作次数，用于下拉选择
	@Provide() workCountList:  Array<number> = [0,1,2,3,4,5,6,7,8,9,10];
				//添加公司信息对话框
	@Provide() companyDialog: boolean = false;
				//添加公司信息下标，表示新增后要返回到哪组数据
	@Provide() companyIndex: number = -1;
				//添加公司信息名称
	@Provide() companyName: String = "";
				//添加公司类型，实习还是工作经验，表示新增后要返回到哪组数据
	@Provide() companyType: number = 0;
				//用户求职信息
	@Provide() userJobSearchDetail: any ={
					targetCountryId:["","",""],
					targetCountry2Id:["","",""],
				};
				//用户选择的工作性质
	@Provide() jobWorkNatures: Array <any> = [];
				//用户选择的目标工作
	@Provide() jobWorkTargets: Array <any> = [];
				//用户选择的工作问题
	@Provide() jobConcerns: any = [];
				//折叠面板
	@Provide() activeNames: String = "1";
				
				//用于resume展示的list
	@Provide() resumeList: Array <any> = [];
				
	@Provide() ifShowFieldOther: boolean = false;
    
    //邮箱表单
    @Provide() ValidateForm: any =  {
                                email: ''
                                };
    
    //表单必填字段 --修改合同时间的原因必填
    @Provide() ContractTimeInfoRules: any = {
          Remarks: [
            { required: true, message: '请输入备注原因', trigger: 'blur' }
          ]
        }
    //表单必填字段 --修改金额弹窗字段
    @Provide() MountInfoRules: any = {
          currencyTypeOptionValue: [
            { required: true, message: '请选择货币类型', trigger: 'change' }
          ],
          contractAmounRemarks: [
            { required: true, message: '请输入备注原因', trigger: 'blur' }
          ],
          dialogMoneyAmount: [
            { required: true, message: '请输入金额数量', trigger: 'blur' }
          ]
        }
    //表单必填字段 修改时间弹窗
    @Provide() TimeInfoRules: any = {
          Remarks: [
            { required: true, message: '请输入备注原因', trigger: 'blur' }
          ],
          totalDuration: [
            { required: true, message: '请输入总课时', trigger: 'blur' }
          ]
        }

    //服务状态  当服务状态改变时，必须要先保存服务状态，才可修改服务状态下的字段 如：失败退款服务状态，保存后才可编辑退款金额
    @Provide() serviceStateChange: boolean = false;
		
	@Provide() editThirdAmount: any =  {
											remarks:"",
											currencyType:"USD",
											moneyAmount:0,
											timestamp:null,
											
										}
										
	@Provide() addThirdAmountDialog: boolean = false;
	@Provide() updThirdAmountDialog: boolean = false;
	
	@Provide() courseDetail: any = {};
	@Provide() courseDetailDialog: boolean = false;
	@Provide() headmasterList: any = [];
	@Provide() changeTimeDialog: boolean = false;
	@Provide() changeTime = null;
	@Provide() signOffDialog: boolean = false;
	@Provide() contractIfTrue: boolean = false;
	@Provide() courseIfTrue: boolean = false;
	@Provide() signOffIfTrue: boolean = false;
	@Provide() ifUpdSuccessTime: boolean = false;
	
	
    //#methods 

    //监听总课时数据
    @Watch('jobWorkTargets')
    watchjobWorkTargets(val: any,oldVal: any): void{
        for(let c=0;c<this.jobWorkTargets.length;c++){
            if(this.jobWorkTargets[c] == 'Other'){
                this.ifShowFieldOther = true;
                return;
            }
        }
        this.ifShowFieldOther = false;
    }

    //监听路由参数变化
    @Watch('$route')
    watchRouterParamsChange(val: any,oldVal: any): void{
        //查询课节信息
        this.queryCourseInfo();
    }
	
	changetypeId(){
		this.editThirdAmount.typeId = null;
		this.$forceUpdate();
	}
	
	confirmCourseEndTime(){
		this.changeTime = this.CourseInfoForm.courseEndTime;
		this.confirmSignOffTime();
	}
	
	confirmContractEndTime(){
		this.changeTime = this.CourseInfoForm.contractEndTime;
		this.confirmSignOffTime();
	}
	
	confirmSignOffTime(){
		if(this.changeTime == null){
			this.$message({
				message: '选择时间后再确认',
				type: "info",
				duration: 2000
			});
			return;
		}
		this.loading = true;
		utils.requestPost("修改交付时间", "course/updSubmissionTime",{
			submissionTime:this.changeTime,
			id:this.CourseInfoForm.id
		}).then((data) => {
			this.$message({
				message: '确认交付时间成功',
				type: "success",
				duration: 2000
			});
			this.signOffDialog = false;
			this.changeTimeDialog = false;
			this.loading = false;
			this.ifUpdSuccessTime = true;
			this.CourseInfoForm.submissionTime = this.changeTime;
		})
	}
	
	checkSignOff(){
		this.$confirm('客户是否已经签署Sign-Off合同并且合同是否已上传？', '提示', {
		  confirmButtonText: '是',
		  cancelButtonText: '否',
		}).then(() => {
		  this.signOffDialog = true;
		  this.changeTimeDialog = false;
		}).catch(() => {
		        
		});
	}
	
	showChangeTimeDialog(){
		//判断合同时间是否可以选择
		if(this.CourseInfoForm.contractEndTime != ''){
			let time1 = new Date(this.CourseInfoForm.contractEndTime);
			let time2 = new Date();
			if(time2.getTime() >= time1.getTime()){
				this.contractIfTrue = true;
			}else{
				this.contractIfTrue = false;
			}
		}else{
			this.contractIfTrue = false;
		}
		
		//判断结课时间是否可以选择
		if(this.CourseInfoForm.courseEndTime != ''
		&& this.CourseInfoForm.courseName.indexOf("DP") == -1 
		&& this.CourseInfoForm.courseName.indexOf("LP") == -1
		&& this.CourseInfoForm.courseName.indexOf("LH") == -1){
			this.courseIfTrue = true;
		}else{
			this.courseIfTrue = false;
		}
		
		//判断signOff时间是否可以选择
		if(this.CourseInfoForm.courseName.indexOf("DP") != -1
		|| this.CourseInfoForm.courseName.indexOf("LP") != -1
		|| this.CourseInfoForm.courseName.indexOf("LH") != -1){
			this.signOffIfTrue = true;
		}else{
			this.signOffIfTrue = false;
		}
		
		
		this.changeTimeDialog = true;
		this.changeTime = null;
	} 
	
	checkUpdCourse(){
		if(this.courseDetail.courseName == null || this.courseDetail.courseName.length == 0){
			this.$message({
				message: '请输入课程名称后再继续',
				type: 'info',
			})
			return;
		}
		for(let i=0;i<this.headmasterList.length;i++){
			if(this.headmasterList[i].id == this.courseDetail.headmasterId){
				this.courseDetail.headmasterUid = this.headmasterList[i].uid;
				break;
			}
		}
		
		this.loading = true;
		utils.requestPost("课程管理修改课程", "course/updCourse",this.courseDetail).then((data) => {
			if(data.error_info.errno == 1){
				this.$message({
					message: '修改课程成功',
					type: "success",
					duration: 2000
				});
				this.courseDetailDialog = false;
				this.queryCourseInfo();
			}else{
				this.$message({
					message: "修改失败："+data.error_info.error,
					type: "warning",
					duration: 5000
				});
			}
			this.loading = false;
		})
	}
	
	showUpdCourse(detail){
		console.log(detail)
		utils.requestGet("课程管理查询课程", "course/getHeadmasters",null).then((data) => {
			this.headmasterList = data;
			this.courseDetail.headmasterId = detail.headmasterId;
			this.courseDetail.id = detail.id;
			this.courseDetail.courseName = detail.courseName;
			this.courseDetail.email = detail.email;
			this.courseDetailDialog = true;
		})
		
	}
	
	showUpdThirdAmount(item){
			this.updThirdAmountDialog = true;
			this.editThirdAmount = JSON.parse(JSON.stringify(item));
			this.editThirdAmount.oldMoneyAmount = this.editThirdAmount.moneyAmount;
			if(this.editThirdAmount.typeId == 0){
				this.editThirdAmount.typeId = null;
			}
		}
		
		delThirdAmount(item){
			this.$confirm('确定要删除此金额吗？', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
				item.courseId =this.$route.params.id;
				this.loading = true;
				utils.requestPost("删除第三方佣金",
				    "course/delThirdAmount",item
				).then((data: any) => {
				    this.$message({
				        showClose: true,
				        message: '删除成功！',
				        type: 'success'
				    });
					this.queryCourseInfo();
				})
			}).catch(() => {
			    
			});
		}
		
		checkUpdThirdAmount(){
			if(this.editThirdAmount.moneyAmount.length == 0){
				this.$message({
				    showClose: true,
				    message: '请输入金额数量',
				    type: 'warning'
				});
				return;
			}
			if(this.editThirdAmount.timestamp == null){
				this.$message({
				    showClose: true,
				    message: '请选择记录日期',
				    type: 'warning'
				});
				return;
			}
			if(this.editThirdAmount.typeId == null){
				this.$message({
				    showClose: true,
				    message: '请选择费用类型',
				    type: 'warning'
				});
				return;
			}
			if(this.editThirdAmount.remarks.length == 0){
				this.$message({
				    showClose: true,
				    message: '请输入备注',
				    type: 'warning'
				});
				return;
			}
			this.editThirdAmount.courseId =this.$route.params.id;
			this.editThirdAmount.oldMoneyAmount = Math.abs(this.editThirdAmount.oldMoneyAmount);
			this.loading = true;
			utils.requestPost("修改第三方佣金",
			    "course/updThirdAmount",this.editThirdAmount
			).then((data: any) => {
				this.updThirdAmountDialog = false;
			    this.$message({
			        showClose: true,
			        message: '修改成功！',
			        type: 'success'
			    });
				this.queryCourseInfo();
			})
		}
		
		checkAddThirdAmount(){
			if(this.editThirdAmount.moneyAmount.length == 0){
				this.$message({
				    showClose: true,
				    message: '请输入金额数量',
				    type: 'warning'
				});
				return;
			}
			if(this.editThirdAmount.timestamp == null){
				this.$message({
				    showClose: true,
				    message: '请选择记录日期',
				    type: 'warning'
				});
				return;
			}
			if(this.editThirdAmount.typeId == null){
				this.$message({
				    showClose: true,
				    message: '请选择费用类型',
				    type: 'warning'
				});
				return;
			}
			if(this.editThirdAmount.remarks.length == 0){
				this.$message({
				    showClose: true,
				    message: '请输入备注',
				    type: 'warning'
				});
				return;
			}
			this.editThirdAmount.courseId =this.$route.params.id;
			
			this.loading = true;
			utils.requestPost("新增第三方佣金",
			    "course/addThirdAmount",this.editThirdAmount
			).then((data: any) => {
				this.addThirdAmountDialog = false;
			    this.$message({
			        showClose: true,
			        message: '新增成功！',
			        type: 'success'
			    });
				this.queryCourseInfo();
			})
		}
		
		showAddThirdAmount(){
			this.addThirdAmountDialog = true;
			this.editThirdAmount = {
				remarks:"",
				currencyType:"USD",
				moneyAmount:0,
				timestamp:null,
				transactionType:8,
			};
		}

    //当服务状态改变时，必须要先保存服务状态，否则会消息提示 如：失败退款服务状态，保存后才可编辑退款金额
    messageServiceState(){
        if(this.serviceStateChange){
            this.$message({
                showClose: true,
                message: '请先保存服务状态后，再修改此信息',
                type: 'warning'
            });
        }
    }

    //切换tabs标签
    handleSwitchClick(tab: any, event: object) {
        if (tab.name === 'second') {
            //金额历史表信息
            this.queryMoneyInfo();
        } else if (tab.name === 'third') {
            //查询状态历史记录
            this.queryStateInfo();            
        } else  if (tab.name === 'first'){
            //查询课节信息
            this.queryCourseInfo();
        } else if (tab.name === "fourth"){
            this.queryStudentInfos('ValidateForm');
        }
        else  if (tab.name === 'fifth'){
            //查询时间历史信息
            this.queryTimeInfo();
        }
    }

    //当为readonly时提示需要点击修改按钮
    clickModificationTips(falg: boolean) {
        if (falg) {
            //只读状态
        }
    }


    //总课时的无穷大以及数值
    totalDurationMethod(){
        //数值
        if(this.TimeInfoForm.totalDurationRadio.toString() == '0'){
            this.TimeInfoForm.readOnly = true;
        }
        //无穷大
        else{
            this.TimeInfoForm.readOnly = false;
        }
    }

    // 分页改变尺寸 金额
    handleSizeChangeMoney(val: any) {
         this.queryInfoMoney.pageSize = val;
    }
    // 分页改变尺寸 状态
    handleSizeChangeState(val: any) {
        this.queryInfoState.pageSize = val;
    }
    // 分页改变尺寸 时间
    handleSizeChangeTime(val: any) {
        this.queryInfoTime.pageSize = val;
    }
    //分页改变当前页 金额
    handleCurrentChangeMoney(val: any) {
        this.queryInfoMoney.pageNum = val;
    }
    //分页改变当前页 状态
    handleCurrentChangeState(val: any) {
        this.queryInfoState.pageNum = val;
    }
    //分页改变当前页 时间
    handleCurrentChangeTime(val: any) {
        this.queryInfoTime.pageNum = val;
    }
    //查询课节信息
    queryCourseInfo() {
        let id = this.$route.params.id;
        if (typeof(id) != "undefined"){ 
            //当进行加载信息时，按钮不可进行编辑
            this.loading = true;

            utils.requestGet("查询课程信息",
            "course/CourseInfo/" + id, null
            ).then((data: any) => {
                if (data.totalDuration < 0) {
                    data.totalDurationRadio = '0';
                    data.totalDuration = data.leftDuration = '+ ∞';
                } else {
                    data.totalDurationRadio = '1';
                }
                data.remainingBudgetCNY = data.remainingBudgetCNY.toFixed(2);
                data.remainingBudgetUSD = data.remainingBudgetUSD.toFixed(2);
                data.averageMonthlyBudgetCNY = data.averageMonthlyBudgetCNY.toFixed(2);
                data.averageMonthlyBudgetUSD = data.averageMonthlyBudgetUSD.toFixed(2);
                data.actualAverageMonthlyCostCNY = data.actualAverageMonthlyCostCNY.toFixed(2);
                data.actualAverageMonthlyCostUSD = data.actualAverageMonthlyCostUSD.toFixed(2);
				data.leftDurationValue = utils.convertHours(data.leftDuration);

                this.CourseInfoForm = data;
                //邮箱赋值
				this.$refs.profile.initStudent(data.email);
                this.ValidateForm.email = data.email;
                
                this.changeServiceJudgment();

                //释放编辑按钮
                this.loading = false;
            })
        }        
    }

    //查询学生信息
    queryStudentInfos(formName: string): void {
		console.log(this.ValidateForm.email)
        this.$refs.profile.initStudent()
    }
    //学生信息切换信息tab
    checkDownload(index: number): void{
				if(index == 0){
					if(this.proinfo.resume != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							for(let i=0;i<this.proinfo.resume.length;i++){
								window.open(this.proinfo.resume[i].url);
							}
						})
					}
				}
				if(index == 1){
					if(this.proinfo.coverLetter != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.coverLetter.url);
						})
					}
				}
				if(index == 2){
					if(this.proinfo.linkedinProfileSummary != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.linkedinProfileSummary.url);
						})
					}
				}
				if(index == 3){
					if(this.proinfo.networkingEmail != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.networkingEmail.url);
						})
					}
				}
				if(index == 4){
					if(this.proinfo.followUpEmail != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.followUpEmail.url);
						})
					}
				}
				if(index == 5){
					if(this.proinfo.thankYouLetter != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.thankYouLetter.url);
						})
					}
				}
			}

    //暂存方法
    stage(moneyAmount: string,dialogMoneyAmount: number){
        this.$refs['MountInfoForm'].validate((valid: any): any => {
            if (valid) {
                //当进行加载信息时，按钮不可进行编辑
                this.loading = true;
                //将金额暂存到表单中
                this.CourseInfoForm[moneyAmount] = dialogMoneyAmount;
                //关闭
                this.MountInfoForm.dialogVisible = false;

                //临时将暂存改为直接修改 重置表单数据
                this.stageForm = [];
                this.stageForm.push(
                    {
                        "op": "replace",
                        "path": "/"+moneyAmount+"Remarks",
                        "value": this.MountInfoForm.contractAmounRemarks
                    },{
                        "op": "replace",
                        "path": "/"+moneyAmount,
                        "value": this.MountInfoForm.dialogMoneyAmount
                    },{
                        "op": "replace",
                        "path": "/"+moneyAmount+"CurrencyType",
                        "value": this.MountInfoForm.currencyTypeOptionValue
                    },{
                        "op": "replace",
                        "path": "/"+moneyAmount+"TransactionId",
                        "value": this.MountInfoForm.dialogMoneyAmountId
                    }
                );

                //直接修改金额信息
                utils.requestPatch("修改课程金额信息","course/updatePatchCourseInfo/"+this.$route.params.id,this.stageForm).then(res => {
                    this.$message({
                        showClose: true,
                        message: res == 'successful'? '修改成功' : res,
                        type: res == 'successful'? 'success' : 'info'
                    });
                    //释放编辑按钮
                    this.loading = false;
                    //课节信息
                    this.queryCourseInfo();
                })
        } else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    //显示修改金额弹窗
    MoneyChange(title: string, amount: number, moneyAmount: any,TransactionId: any,Remarks: any,CurrencyType: any,key: number,remarks: string,type: string,...restOfName: string[]) {
        this.messageServiceState();
        if(!this.serviceStateChange){
            this.MountInfoForm.dialogTitle = title;
            this.MountInfoForm.dialogVisible = true;
            this.MountInfoForm.moneyAmount = moneyAmount;
            this.MountInfoForm.TransactionId = TransactionId;
            this.MountInfoForm.Remarks = Remarks;
            this.MountInfoForm.CurrencyType = CurrencyType;
            this.MountInfoForm.dialogMoneyAmount = amount;
            this.MountInfoForm.dialogMoneyChange = 0;
            this.MountInfoForm.dialogMoneyAmountId = key
            this.MountInfoForm.currencyTypeOptionValue = type;
            this.MountInfoForm.contractAmounRemarks = remarks;
            this.MountInfoForm.restOfName = restOfName[0];

            //当预算金额货币类型不存在时，将签约类型赋值
            this.typeCheck();

            if(title=='预算金额'){
                this.MountInfoForm.disabled = true;
            }
        }   
    }
    //检测类型
    typeCheck(){
        if(this.CourseInfoForm.contractAmountCurrencyType==null&&this.CourseInfoForm.budgetAmountCurrencyType!=null){
            this.CourseInfoForm.contractAmountCurrencyType = this.CourseInfoForm.budgetAmountCurrencyType
            this.MountInfoForm.currencyTypeOptionValue = this.CourseInfoForm.budgetAmountCurrencyType;
            // this.MountInfoForm.disabled = true;
        }
        else if(this.CourseInfoForm.contractAmountCurrencyType!=null&&this.CourseInfoForm.budgetAmountCurrencyType==null){
            this.CourseInfoForm.budgetAmountCurrencyType = this.CourseInfoForm.contractAmountCurrencyType;
            this.MountInfoForm.currencyTypeOptionValue = this.CourseInfoForm.contractAmountCurrencyType;
            
            // if(this.MountInfoForm.dialogTitle=='预算金额'){
            //     this.MountInfoForm.disabled = true;
            // }
            
        }
        else{
            this.MountInfoForm.disabled = false;
        }
    }
    //显示编辑总课时弹窗
    TotalDurationChange(title: string, amount: number, moneyAmount: any,TransactionId: any,Remarks: any,CurrencyType: any,key: number,remarks: string,type: string,...restOfName: string[]) {
        this.TimeInfoForm.dialogVisible = true;
        this.TimeInfoForm.dialogTitle = title;
        this.TimeInfoForm.totalDuration = this.CourseInfoForm.totalDuration;
        this.TimeInfoForm.totalDurationRadio = this.CourseInfoForm.totalDurationRadio;
    }
    //显示修改金额弹窗 改变金额数量
    moneyChangeAmount(amount: number, dialogMoneyAmount: number) {
        this.MountInfoForm.dialogMoneyChange = dialogMoneyAmount - amount;
    }
    //显示编辑合同时间 弹窗
    ContractTotalChange(title: string, fieldName: string,type: number,value: string) {
        this.messageServiceState();
        if(!this.serviceStateChange){
        this.contractTimeInfoForm.Remarks = "";
        this.contractTimeInfoForm.dialogVisible = true;
        this.contractTimeInfoForm.dialogTitle = title;
        this.contractTimeInfoForm.fieldName = fieldName;
        this.contractTimeInfoForm.type = type;
        this.contractTimeInfoForm.time = value;
        }
    }
    //查询金额历史信息
    queryMoneyInfo() {
        let id = this.$route.params.id;        
        utils.requestGet("查询金额历史信息",
            "CourseTransactionHistory/history/" + id, null
        ).then((data: any) => {
            data.data.map(({
                fluctuate
            }: any, index: number) => {
                fluctuate ? data.data[index].fluctuate = "增加" : data.data[index].fluctuate = "减少"
            })
			for(let i=0;i<data.data.length;i++){
				if(data.data[i].transactionType == 8){
					data.data[i].beijing = data.data[i].beijing.substring(0,10);
					data.data[i].dalas = data.data[i].dalas.substring(0,10);
				}
			}
            this.moneyInfolist = data.data;
            this.totalMoney = data.total;
        })
    }
    //查询状态历史信息
    queryStateInfo() {
        let id = this.$route.params.id;
        utils.requestGet("查询状态历史信息",
            "StateTransactionHistory/Histories/" + id, null
        ).then((data: any) => {
            this.stateInfolist = data.data;
            this.totalState = data.total;
        })
    }

    //查询时间历史信息
    queryTimeInfo() {
        let id = this.$route.params.id;
        utils.requestGet("查询时间历史信息",
            "TimeRecordHistory/historys/" + id, null
        ).then((data: any) => {
            if(data.data!='undefined'&&data.data!=null){
                data.data.map(({
                    fluctuate,fieldContent
                }: any, index: number) => {
                    fluctuate ? data.data[index].fluctuate = "增加" : data.data[index].fluctuate = "减少"
                    fieldContent == '-50000' ? data.data[index].fieldContent = '+ ∞' : ''
                })
                this.timeInfolist = data.data;
                this.totalTime = data.total;
            }            
        })
    }
    /*保存金额*/
    MoneyAmountMethod(){
        this.$refs['MountInfoForm'].validate((valid: any): any => {
            if (valid) {
                //当进行加载信息时，按钮不可进行编辑
                this.loading = true;
                let patchDate = [{
                    "op": "replace",
                    "path": "/"+this.MountInfoForm.moneyAmount,
                    "value": this.MountInfoForm.dialogMoneyAmount
                },{
                    "op": "replace",
                    "path": "/"+this.MountInfoForm.Remarks,
                    "value": this.MountInfoForm.contractAmounRemarks
                },{
                    "op": "replace",
                    "path": "/"+this.MountInfoForm.CurrencyType,
                    "value": this.MountInfoForm.currencyTypeOptionValue
                },{
                    "op": "replace",
                    "path": "/"+this.MountInfoForm.TransactionId,
                    "value": this.MountInfoForm.dialogMoneyAmountId
                }
                ];
            this.$confirm('确认修改此信息吗？', '提示', {
                confirmButtonText: '确定修改',
                cancelButtonText: '我再确认一下',
                type: 'success'
            }).then(() => {
                utils.requestPatch("修改课程中的金额","course/updatePatchCourseInfo/"+this.$route.params.id,patchDate).then(res => {
                    this.$message({
                        showClose: true,
                        message: res == 'successful'? '修改成功' : res,
                        type: res == 'successful'? 'success' : 'info'
                    });
                    this.MountInfoForm.dialogVisible = false;
                    //释放编辑按钮
                    this.loading = false;
                    //课节信息
                    this.queryCourseInfo();
                })
            }).catch(() => {
                //释放编辑按钮
                this.loading = false;
            });
        } else {
                console.log('error submit!!');
                return false;
            }
        });
    }

    //修改合同时间弹窗时确认按钮触发事件
    TimeInfoFormSubmitMethod(): void{
        this.$refs['TimeInfoForm'].validate((valid: any): any => {
            if (valid) {
                if(Number(this.TimeInfoForm.totalDuration)<-5000)
                {
                    this.$message({
                            showClose: true,
                            message: '不能小于-5000',
                            type: 'info'
                        });
                    return ;
                }
                //当进行加载信息时，按钮不可进行编辑
                this.loading = true;

                //patch 请求方式

                let value = Number(this.TimeInfoForm.totalDurationRadio) == 0 ? -50000 : Number(this.TimeInfoForm.totalDuration);

                let patchDate = [{
                        "op": "replace",
                        "path": "/totalDuration",
                        "value": value
                    },{
                        "op": "replace",
                        "path": "/courseFieldReferenceTableKey",
                        "value": 1
                    },{
                        "op": "replace",
                        "path": "/remarks",
                        "value": this.TimeInfoForm.Remarks
                    }];
                this.$confirm('确认修改此信息吗？', '提示', {
                    confirmButtonText: '确定修改',
                    cancelButtonText: '我再确认一下',
                    type: 'success'
                }).then(() => {
                    utils.requestPatch("更改课程信息","course/updatePatchCourseInfo/"+this.$route.params.id,patchDate).then(res => {
                        this.$message({
                            showClose: true,
                            message: res == 'successful'? '修改成功' : res,
                            type: res == 'successful'? 'success' : 'info'
                        });
                        //关闭弹窗
                        this.TimeInfoForm.dialogVisible = false;
                        //释放编辑按钮
                        this.loading = false;
                        //课节信息
                        this.queryCourseInfo();
                    })
                })
        } else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    //合同时间的修改以及原因的添加
    contractTimeInfoFormSubmitMethod(){
            this.$refs['ContractTimeInfoForm'].validate((valid: any): any => {
                if (valid) {
                    //当进行加载信息时，按钮不可进行编辑
                    this.loading = true;
                    let patchDate = [
                        {
                            "op": "replace",
                            "path": "/"+this.contractTimeInfoForm.fieldName,
                            "value": this.contractTimeInfoForm.time
                        },{
                            "op": "replace",
                            "path": "/courseFieldReferenceTableKey",
                            "value": this.contractTimeInfoForm.type
                        },{
                            "op": "replace",
                            "path": "/remarks",
                            "value": this.contractTimeInfoForm.Remarks
                        }
                    ];
                    this.$confirm('确认修改此信息吗？', '提示', {
                        confirmButtonText: '确定修改',
                        cancelButtonText: '我再确认一下',
                        type: 'success'
                    }).then(() => {
                        utils.requestPatch("合同时间的修改以及原因添加","course/updatePatchCourseInfo/"+this.$route.params.id,patchDate).then(res => {
                            this.$message({
                                showClose: true,
                                message: res == 'successful'? '修改成功' : res,
                                type: res == 'successful'? 'success' : 'info'
                            });
                            //关闭弹窗
                            this.contractTimeInfoForm.dialogVisible = false;
                            //释放编辑按钮
                            this.loading = false;
                            //课节信息
                            this.queryCourseInfo();
                        })
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
    }
    //将暂停合同时间 暂存 改为 直接修改
    suspensionTimeInfoFormSubmitMethod(){
        this.$refs['ContractTimeInfoForm'].validate((valid: any): any => {
            //直接修改 重置数据表单
            this.stageForm = [];
            if (valid) {
                //当进行加载信息时，按钮不可进行编辑
                this.loading = true;
                this.stageForm.push(
                    {
                        "op": "replace",
                        "path": "/"+this.contractTimeInfoForm.fieldName,
                        "value": this.contractTimeInfoForm.time
                    },{
                        "op": "replace",
                        "path": "/courseFieldReferenceTableKey"+this.contractTimeInfoForm.type,
                        "value": this.contractTimeInfoForm.type
                    },{
                        "op": "replace",
                        "path": "/remarks"+this.contractTimeInfoForm.type,
                        "value": this.contractTimeInfoForm.Remarks
                    }
                );
                this.CourseInfoForm[this.contractTimeInfoForm.fieldName] = this.contractTimeInfoForm.time
                utils.requestPatch("更改课程暂停合同时间","course/updatePatchCourseInfo/"+this.$route.params.id,this.stageForm).then(res => {
                    this.$message({
                        showClose: true,
                        message: res == 'successful'? '修改成功' : res,
                        type: res == 'successful'? 'success' : 'info'
                    });
                    //释放编辑按钮
                    this.loading = false;
                    //课节信息
                    this.queryCourseInfo();
                })
                //关闭弹窗
                this.contractTimeInfoForm.dialogVisible = false;
        } else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    /*保存课节信息修改按钮*/
    HoursAndContractConfirm() {
        this.$confirm('确认修改此信息吗？', '提示', {
            confirmButtonText: '确定修改',
            cancelButtonText: '我再确认一下',
            type: 'success'
        }).then(() => {
            //当进行加载信息时，按钮不可进行编辑
            this.loading = true;
            utils.requestPost("更改课节合同信息",
                "course/updateHoursAndContract", this.CourseInfoForm
            ).then((data: any) => {
                utils.getUSDExchangeRate().then((rate: any) => {
                    this.dialogVisible3 = false;
                    this.$message({
                        showClose: true,
                        message: '修改成功！',
                        type: 'success'
                    });
                    //当进行加载信息时，按钮不可进行编辑
                    this.loading = true;
                })
            })
        })
    }

    

    //将readonly  改为 可编辑
    editInput(index: number, refName: string, refNameInput: string) { 
        if (this.formReadOnly[index]) {
			if(this.CourseInfoForm.submissionTime == ''){
				console.log("交付时间不存在")
				this.ifUpdSuccessTime = false;
				if(this.CourseInfoForm.serviceStateId == 5 || this.CourseInfoForm.serviceStateId == 6 || this.CourseInfoForm.serviceStateId == 7){
					this.showChangeTimeDialog();
				}
			}else{
				this.ifUpdSuccessTime = true;
			}
            this.$refs[refName].$el.innerText = '保存';
            try {
                this.$refs[refNameInput].focus();
            } catch {
                
            }
        } else {
			
			if((this.CourseInfoForm.serviceStateId == 5 || this.CourseInfoForm.serviceStateId == 6 || this.CourseInfoForm.serviceStateId == 7) && !this.ifUpdSuccessTime){
				this.$message({
					message: '请先确认交付时间',
					type: "info",
					duration: 2000
				});
				return;
			}
			
            //保存 - 服务状态初始化
            this.serviceStateChange = false;

            //当进行加载信息时，按钮不可进行编辑
            this.loading = true;
            let value = refName === "totalDuration" ? (this.CourseInfoForm['totalDurationRadio'] === "0" ? -50000 : this.CourseInfoForm['totalDuration']) : this.CourseInfoForm[refName];
                        
            let patchDate = [{
                "op": "replace",
                "path": "/"+refName,
                "value": value
            }];

            this.stageForm.map(item=>patchDate.push(item))
            utils.requestPatch("更改课程基础信息","course/updatePatchCourseInfo/"+this.$route.params.id,patchDate).then(res => {
                this.$message({
                    showClose: true,
                    message: res == 'successful'? '修改成功' : res,
                    type: res == 'successful'? 'success' : 'info'
                });
                //释放编辑按钮
                this.loading = false;
                //课节信息
                this.queryCourseInfo();
            })
            this.$refs[refName].$el.innerText = '修改';
        }
        this.formReadOnly.splice(index, 1, !this.formReadOnly[index])
    }
    //判断该优评奖金是否存在值‘
    validateAwardAmount(){
        if(this.CourseInfoForm.awardAmount>0){
            return true;
        }
        else{
            utils.requestGet("判断该优评奖金是否存在值",
            "StateTransactionHistory/StateValidate/" + this.$route.params.id, null
            ).then((data: any) => {
                if(data){
                    return false;
                }
                else
                    return true;
            })
        }   
    }
    //服务状态改变判断
    changeServiceJudgment() {
        //判断服务状态是否变化
        if(this.$refs['serviceStateId'].$el.innerText == '保存'){
            this.serviceStateChange = true;
			if((this.CourseInfoForm.serviceStateId == 5 || this.CourseInfoForm.serviceStateId == 6 || this.CourseInfoForm.serviceStateId == 7) && 
			this.CourseInfoForm.submissionTime == ''){
				this.showChangeTimeDialog();
			}
        }
		
		
		
        
        //当服务状态变化时，暂存中的数据将重置
        this.stageForm = [];
        //判断服务状态是否存在
        if (this.serviceStateOptionsEdit.length > 0) {
			for(let i=0;i<this.serviceStateOptionsEdit.length;i++){
				if (this.CourseInfoForm.serviceStateId > 0) {
					if(this.serviceStateOptionsEdit[i].value == this.CourseInfoForm.serviceStateId){
						this.serviceStateOptionsEdit[i].label.indexOf("暂停中") != -1 ? this.suspendedFlag = true : this.suspendedFlag = false;
						this.serviceStateOptionsEdit[i].label.indexOf("失败退款") != -1 ? this.failureRefundFlag = true : this.failureRefundFlag = false;
						this.serviceStateOptionsEdit[i].label.indexOf("成功内推") != -1 ? this.SuccessfulIntroversionFlag = true : this.SuccessfulIntroversionFlag = false;
						if(this.serviceStateOptionsEdit[i].label.indexOf("成功完结") != -1
						|| this.serviceStateOptionsEdit[i].label.indexOf("成功内推") != -1 || this.serviceStateOptionsEdit[i].label.indexOf("失败退款") != -1){
							this.serviceEnd = true;
							this.InitialSuccess = true;
						}else{
							this.serviceEnd = false;
							this.InitialSuccess = false;
						}
					}
				}
			}
			
        }
    }
    queryServiceState() {
        //服务状态数据获取
        //下拉菜单选择 服务状态
        utils.requestGet("获取服务状态和其他费用可用类型",
            "ServiceState/QueryServiceStatusOptions", null
        ).then((data: any) => {
            this.serviceStateOptionsEdit = data.states;
			this.courseTransitionTypes = data.types;
            //课节信息
            this.queryCourseInfo();
        })
    }
    mounted(){
        window.onresize = ()=>{this.tabelHeight = window.innerHeight;};
    }
    created() {
        //查询服务状态
        this.queryServiceState();
    }

}
